import { render, staticRenderFns } from "./TaxInvoices.vue?vue&type=template&id=6adf3cf6&"
import script from "./TaxInvoices.vue?vue&type=script&lang=js&"
export * from "./TaxInvoices.vue?vue&type=script&lang=js&"
import style0 from "./TaxInvoices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports